'use client';

import type { DateValue } from '@internationalized/date';
import clsx from 'clsx';
import { ReactElement } from 'react';

import { PROVIDER_SCHEDULING_TYPES } from '@provider-directory/constants';
import type {
  ProviderLocationResource,
  ProviderResource,
  ProvidersSearchCriteria,
} from '@provider-directory/types/providers.contracts';

import { ProviderCardGrid } from './provider-card-grid';
import { ProviderCardLocation } from './provider-card-location';
import { ProviderCardScheduling } from './provider-card-scheduling';

export interface ProviderSearchCardDropdownProps {
  provider: ProviderResource;
  location: ProviderLocationResource;
  startDate?: DateValue | null;
  endDate?: DateValue | null;
  searchCriteria?: Partial<ProvidersSearchCriteria>;
  showDivider?: boolean;
}

export const ProviderSearchCardDropdown = ({
  provider,
  location,
  startDate,
  endDate,
  searchCriteria,
  showDivider = true,
}: ProviderSearchCardDropdownProps): ReactElement => {
  return (
    <ProviderCardGrid>
      {showDivider && (
        <div
          className={
            'col-span-2 mb-6 tablet:mb-[32px] desktop:col-start-2 desktop:mb-[16px]'
          }
        >
          <hr className={'border-gray-200'} />
        </div>
      )}

      <div
        className={clsx(
          'col-span-full col-start-1 desktop:col-span-1 desktop:col-start-2',
          'tablet:row-span-2 desktop:row-span-2',
        )}
      >
        <ProviderCardLocation location={location} provider={provider} />
      </div>
      {provider.scheduling !== PROVIDER_SCHEDULING_TYPES.None && (
        <div
          className={clsx(
            'col-span-full col-start-1 desktop:col-span-1 desktop:col-start-3',
            'tablet:row-span-2 desktop:row-span-2',
            'flex items-center justify-center',
          )}
        >
          <ProviderCardScheduling
            provider={provider}
            location={location}
            startDate={startDate}
            endDate={endDate}
            searchCriteria={searchCriteria}
            showBookAnotherProviderButton={false}
            schedulingContext={'dropdown'}
          />
        </div>
      )}
    </ProviderCardGrid>
  );
};
